export default Object.freeze({
  INTRO:
    'https://res.cloudinary.com/riteshp2000/image/upload/w_auto,f_auto,q_auto/v1637704396/project-guava/c12faf4e16c523579338ec751a34258c_1_yjnysy.png',
});
